/**
 * Gets the hours in a day numbered 0 to 23
 *
 * @returns - An array with each hour of the day
 */
export function getHoursOfDay(): number[] {
    return Array(24)
        .fill(null)
        .map((_, index) => index);
}
